<template>
  <div v-bind:class="waybillSelect==='2'?'waybill-container isactive':'waybill-container'">
    <el-table :data="waybillList.result"
              style="width: 100%"
              height="100%">
      <el-table-column class-name="number"
                       label="序号"
                       align="center"
                       type="index"
                       fixed
                       min-width="40">
      </el-table-column>
      <el-table-column class-name="sourceNumber"
                       prop="orderNum"
                       label="运单编号">
      </el-table-column>
      <el-table-column label="货主公司">
        <template slot-scope="scope">
          <div>{{scope.row.companyName}}</div>
        </template>
      </el-table-column>
      <el-table-column label="物流公司">
        <template slot-scope="scope">
          <div>{{scope.row.userCompanyName}}</div>
        </template>
      </el-table-column>
      <el-table-column label="位置信息">
        <template slot-scope="scope">
          <div><span>出发地：</span>{{scope.row.departLand}}{{scope.row.departLandDetails}}</div>
          <div><span>目的地：</span>{{scope.row.destina}}{{scope.row.destinaDetails}}</div>
        </template>
      </el-table-column>
      <el-table-column label="货源匹配信息">
        <template slot-scope="scope">
          <div><span>原料：</span>{{scope.row.material}}</div>
          <div><span>重量：</span>{{scope.row.orderWeight}}吨</div>
          <div><span>谈成运费:</span>{{scope.row.talkFreight}}元</div>
        </template>
      </el-table-column>
      <el-table-column label="状态"
                       header-align="center"
                       align="center"
                       width="67">
        <template slot-scope="scope">
          <div v-if="scope.row.orderState === '0'"
               class="status-style wating">待运输</div>
          <div v-else-if="scope.row.orderState === '1'"
               class="status-style progress">运输中</div>
          <div v-else-if="scope.row.orderState === '2'"
               class="status-style complated">运输完成</div>
          <div v-else-if="scope.row.orderState === '3'"
               class="status-style failure">已取消</div>
        </template>
      </el-table-column>
      <el-table-column header-align="center"
                       prop="operation"
                       label="操作"
                       max-width="120"
                       align="center">
        <template slot-scope="scope">
          <el-button plain
                     class="btnc"
                     @click="handleWaybillClick(scope.row.companyOrderId)">运单详情</el-button>
        </template>

      </el-table-column>

    </el-table>
    <!-- 分页 -->
    <div class="pages">
      <span class="demonstartion"> 共{{waybillList.total}}条记录</span>
      <el-pagination @current-change="handleCurrentChange"
                     :page-size="waybillList.pageSize"
                     layout="prev, pager, next"
                     :total="waybillList.total"
                     background>
      </el-pagination>

    </div>
  </div>
</template>

<script>
import { heightWaybill } from 'apis/index'
import { mapState } from 'vuex'
import Bus from '../../Bus'
export default {
  name: 'Container',
  data () {
    return {
      userPermissionTable: false,
      input: '',
      searchInfo: null,
      pageNum: 1,
      orderState: '',
      waybillSelect: '1'

    }
  },
  computed: mapState({
    waybillList: state => state.heightWaybill.waybillInfo

  }),
  methods: {
    getData () {
      if (this.searchInfo) {
        // console.log(this.)
        heightWaybill({
          pageNum: this.pageNum,
          orderState: this.orderState,
          departLand: this.searchInfo.from,
          destina: this.searchInfo.to,
          material: this.searchInfo.material,
          userCompanyName: this.searchInfo.userCompanyName,
          companyName: this.searchInfo.companyName,
          goodsNum: this.searchInfo.goodsNu
        }).then(res => {
          if (res.data.code === 0) {
            const waybillList = res.data.data.result
            this.$store.commit('heightWaybill/updateData', waybillList)
          }
        })
      } else {
        heightWaybill({
          orderState: this.orderState,
          pageNum: this.pageNum
        }).then(res => {
          if (res.data.code === 0) {
            const waybillList = res.data.data.result
            this.$store.commit('heightWaybill/updateData', waybillList)
          }
        })
      }
    },
    handleWaybillClick (id) { // 查看运单详情
      this.$router.push({ path: 'waybillDetail', query: { item: id } })
    },
    handleCurrentChange (val) { // 切页切换
      this.pageNum = val
      this.getData()
      // this.activeName = ''
      // console.log(this.searchInfo)
      // if (this.searchInfo) {
      //   console.log('高级查询')
      // } else {
      //   console.log('普通')
      // }
      // heightWaybill({
      //   pageNum: this.pageNum

      // }).then(res => {
      //   if (res.data.code === 0) {
      //     const waybillList = res.data.data.result
      //     this.$store.commit('heightWaybill/updateData', waybillList)
      //   }
      // })
    }
  },
  mounted () {
    this.getData()
    Bus.$on('getSearchInfo', res => {
      this.searchInfo = res
      // console.log('aaa', this.searchInfo)
    })
    Bus.$on('getOrderState', res => {
      // console.log('bbb', res)
      this.orderState = res
    })
    Bus.$on('waybillSelect', res => {
      this.waybillSelect = res
    })
  }
}
</script>
<style lang="stylus">
@import '~styles/mixins.styl'
.waybill-container
  margin-left 20px
  margin-top 10px
  margin-right 20px
  height calc(100% - 120px)
  .el-table th
    background #e7f0f8
  .el-table td div
    size12()
  .el-table th>.cell
    size12()
  .status-style
    width 40px
    height 40px
    border-radius 50%
    border 1px solid transparent
    size10()
    line-height 40px
    text-align center
  .wating
    wating()
  .progress
    progress()
  .complated
    complated()
  .failure
    failure()
    size10()
  .el-button
    size12()
    margin-bottom 10px
    margin-left 10px
  .btnc
    btnc()
  .companyInfo, .materialInfo
    width 108px
    margin 0 auto
  .location
    width 150px
    margin 0 auto
  .userPermissionTable
    .el-dialog
      width auto
      width 728px
      .el-dialog__header
        height 42px
        padding 0 20px 0
        background #1b88ee
        .el-dialog__title
          line-height 42px
          font-size 13px
          color #fff
          float left
        .el-dialog__headerbtn
          top 12px
          right 12px
          .el-dialog__close
            color #fff
            font-size 20px
      .el-dialog__body
        padding 15px 20px
        .companySelect
          width 180px
          height 30px
          margin 0
          float left
          margin-bottom 20px
          .el-input__inner
            width 145px
            height 30px
          .el-input-group__append
            padding 0
            .el-button
              margin 0
            .el-button--mini, .el-button--mini.is-round
              padding 7px 12px
        .operation
          .el-button
            margin 0
            padding 7px 27px
  .pages
    margin-top 15px
    margin-bottom 15px
    .demonstartion
      float right
      line-height 45px
      color #5e656f
  .el-table td, .el-table th
    vertical-align top
.isactive
  height calc(100% - 216px)
</style>
